<template>
  <v-card class="transparent elevation-0 mb-4 ml-2">
    <div class="d-flex flex-no-wrap justify-space-between">
      <div>
        <v-card-title class="title">Get the Texel app now!</v-card-title>
        <v-card-text class="subtitle font-weight-bold">Your trip to Texel has been created. Continue planning your trip by adding your favorite activities.</v-card-text>

        <v-layout row>
          <v-card-text>
Get the Texel app and be inspired about all your can see and do on this beautiful island. The Texel app offers you a lot of benefits for your visit to Texel. Easily find, book and access your favorite activities. Get special discounts on activities and shopping with your personal Texel Passport in the app.
<br />
<br />
Let the app guide you during your stay with way finding and on demand suggestions for fun activities, food and drinks. Become a real Texelaar with fun quizes, finding hidden gems and earning reward points that unlock exclusive activities and discounts.
<br />
<br />
The Texel app is all you need to get the most out of your visit to Texel. </v-card-text>
          <v-avatar class="mt-5" size="400" tile>
            <v-img height="500" :src="require('../assets/TexelAppMock.png')" contain="false"></v-img>
          </v-avatar>
        </v-layout>
      </div>
    </div>
    <br />
    <v-img width="150" :src="require('../assets/appStoreDownload.svg')" />

    <!-- <v-card-title class="headline">Your trip has been created! Please continue on the Visit Texel app</v-card-title>
          <v-card-text>
            <h3>Download the App in the App Store to continue configuring your trip</h3>
            <br />
            <p class="setFontSize" :style="getFontProperty()">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse porttitor nunc id elit luctus, ac tempor enim consectetur. Sed magna ipsum, pellentesque quis placerat a, fringilla sit amet velit. Curabitur tempus sollicitudin nisi, sed ultrices diam. Vivamus egestas scelerisque metus quis consequat. Quisque dolor tellus, lacinia id consequat semper, laoreet sit amet nulla. Vestibulum consequat iaculis dui eu ornare. Maecenas scelerisque lobortis ligula. Donec at sollicitudin augue. Donec quis augue vehicula, sagittis lacus non, suscipit dolor. Donec in velit posuere, mattis est eget, tempor sem. Vestibulum finibus odio eget egestas tempus. In quis aliquet orci, et pellentesque nibh. Pellentesque arcu justo, congue ullamcorper ipsum quis, pulvinar ornare erat.</p>
            <v-divider></v-divider>
            <br />
            <p><v-img width="150" class="imagePointer" :src="require('../assets/appStoreDownload.svg')"/></p>
    </v-card-text>-->
    <v-divider class="my-5"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" class="text-capitalize" rounded @click="goHome">Create another trip</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";
import { mapGetters } from "vuex";
import BaseObject from "../objects/BaseObject";
import BaseComponent from "./base/BaseComponent.vue";
import { ui_helpers } from "../shared/ui_helpers.js";

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],

  name: "NewTripGoToApp",

  computed: {
    ...mapGetters({
      _webStep: "getWebStepId",
      _tripForm: "getTripForm"
    })
  },

  watch: {},

  data: () => ({}),

  mounted() {},

  methods: {
    goHome() {
      // this._tripForm.activities = [];
      // this._tripForm.ArrivalTime = "";
      // this._tripForm.DepartureTime = "";
      // this._tripForm.startDate = null;
      // this._tripForm.endDate = null;
      // this._tripForm.groupSize = 1;

      this.$router.push({
        name: "Home",
        params: "component"
      });

      this.$store.commit("setWebStepId", this.$store.getters.getWebStepId - 1);
    }
  }
};
</script>
<style>
</style>
